// extracted by mini-css-extract-plugin
export default {"container":"kalW5F6V","mobile":"mobile","logos":"ilupB363","title":"ar3w2y_6","buttons":"ugn1A3Ht","attention":"ua8riMct","description":"J3kGyKLS","agreement":"lvtQES4q"};